export default __webpack_public_path__ + "static/media/wrap.3e178cdc.webp";